import { Box } from '@mui/material'

import { GridCellParams } from '@mui/x-data-grid'
import { StatusLink } from '../../shared/StatusLink'

import { copy } from '../../../Copy'

interface StatusLinkRowCellProps extends GridCellParams {
  copy: typeof copy
}

const StatusLinkRowCell = (params: StatusLinkRowCellProps) => {
  return (
    <Box sx={{ textAlign: 'center', width: '100%' }}>
      <StatusLink
        copy={params.copy}
        fontSize={13}
        status={params.row.status}
        sx={{ width: '100%', height: '100%' }}
      />
    </Box>
  )
}

export default StatusLinkRowCell
